import React, { Component } from 'react';
import { AgGridReact } from "ag-grid-react";
import AccountTransactionServices from '../../../services/axiosServices/apiServices/AccountTransactionServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import { getAuthProps } from '../../../utils/AuthenticationLibrary';
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown';
import { isValidForm } from '../../../utils/validation/CommonValidator';
import { CommonValidationMessages } from '../../../utils/Messages';
import DailyReportsServices from '../../../services/axiosServices/apiServices/DailyReportsServices';
import moment from 'moment';
import MasterEntryServices from '../../../services/axiosServices/apiServices/MasterEntryServices';
import { Navigate } from "react-router-dom";
import { encryptAES } from '../../../utils/Encryption';
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import ButtonLoader from '../../../components/common/buttonLoader/ButtonLoader';
import { getFinancialYearDates } from '../../../utils/DateUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRotateRight } from '@fortawesome/free-solid-svg-icons'

// autoTable(jsPDF.API);

export default class LedgerReport extends Component {
    constructor(props) {
        super(props)
        this.accountTransactionServices = new AccountTransactionServices();
        this.dailyReportsServices = new DailyReportsServices();
        this.masterEntryServices = new MasterEntryServices();
        this.SwalServices = new SwalServices();
        this.gridRef = React.createRef();
        this.state = {
            isLoading: false,
            isModalOpen: false,
            accountName: '',
            footerRow: [
                {
                    docNo: "Opening Balance:",
                    debitAmount: "6,71,42,273.91",
                },
                {
                    docNo: "Total (CR/DR):",
                    debitAmount: "1,00,36,662.00",
                    creditAmount: "75,00,000.00",
                },
                {
                    docNo: "Closing Balance:",
                    cumulativeAmount: "6,96,78,935.91 Dr",
                },
                {
                    docNo: "Grand Total:",
                    debitAmount: "7,71,78,935.91",
                    creditAmount: "7,71,78,935.91",
                },
            ],
            rowData: [],
            partyList: [],
            displayPartyList: [],
            expenseByList: [
                { value: 1, label: "Party" },
                { value: 2, label: "Employee" },
                { value: 3, label: "Bank" },
                { value: 4, label: "Head" }
            ],
            colDefs: [
                {
                    // field: "docNo",
                    headerName: "Sr No",
                    valueGetter: (params) => {
                        return params.node.rowPinned ? '' : params.node.rowIndex + 1;
                    },
                    flex: 0.6,
                    minWidth: window.innerWidth * 0.04,
                    spanRows: true,
                },
                {
                    field: "date",
                    headerName: "Date",
                    flex: 1,
                    filter: true,
                    floatingFilter: true,
                    minWidth: window.innerWidth * 0.07,
                    // valueFormatter: (params) => {
                    //     return params.value ? moment(params.value).format('DD-MM-YYYY') : "";
                    // },
                    spanRows: true,
                },
                {
                    field: "docNo",
                    headerName: "Doc No",
                    flex: 0.8,
                    minWidth: window.innerWidth * 0.05,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "transactionWith",
                    headerName: "Tran. With",
                    flex: 1.5,
                    minWidth: window.innerWidth * 0.23,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "type",
                    headerName: "Vch Type",
                    flex: 1.5,
                    minWidth: window.innerWidth * 0.15,
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "debitAmount",
                    headerName: "Debit Rs.",
                    flex: 1,
                    minWidth: window.innerWidth * 0.09,
                    valueFormatter: (params) => {
                        if (params.node.rowPinned) {
                            return params.value; // Return raw value for pinned rows
                        }
                        return params.value > 0 ? params.value : "";
                    },
                    cellStyle: (params) => {
                        if (params.node.rowPinned) {
                            if (params.data?.type === "Closing Balance") {
                                return { color: 'green' };
                            }
                        }
                        return { color: 'red' };
                    },
                    filter: true,
                    floatingFilter: true,
                },
                {
                    field: "creditAmount",
                    headerName: "Credit Rs.",
                    flex: 1,
                    minWidth: window.innerWidth * 0.09,
                    filter: true,
                    floatingFilter: true,
                    valueFormatter: (params) => {
                        if (params.node.rowPinned) {
                            console.log(params.node.rowPinned);
                            return params.value;
                        }
                        return params.value > 0 ? params.value : "";
                    },
                    cellStyle: (params) => {
                        if (params.node.rowPinned) {
                            if (params.data?.type === "Closing Balance") {
                                return { color: 'red' };
                            }
                        }
                        return { color: 'green' };
                    }
                },
                {
                    field: "cumulativeAmount",
                    headerName: "Cumulative Rs.",
                    flex: 1,
                    minWidth: window.innerWidth * 0.09,
                    filter: true,
                    floatingFilter: true,
                    cellStyle: (params) => {
                        if (params?.value?.includes('DR')) {
                            return { color: 'red' };
                        } else if (params?.value?.includes('CR')) {
                            return { color: 'green' };
                        }
                        return null;
                    }
                },
            ],
            openingBalance: "",
            openingBalanceType: "DR",
            paginationPageSize: 50,
            rowHeight: 40,
            idCompany: 0,
            idUser: 0,
            requestDetails: {
                fromDate: "",
                toDate: "",
                partyId: 0,
                exponseById: 1
            },
            validState: {
                isValid: true,
                error: {},
            },
            validationRules: {
                fromDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "from date"
                        ),
                    }
                ],
                toDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "to date"
                        ),
                    }
                ],
                partyId: [
                    {
                        type: "require",
                        message: CommonValidationMessages.SelectRequired.replace(
                            "{0}",
                            "person name"
                        ),
                    }
                ],
            },
        }
    }

    componentDidMount = () => {
        let prop = getAuthProps()
        //debugger
        let requestDetails = localStorage.getItem("ledgerReportDetails");
        if (requestDetails) {
            requestDetails = JSON.parse(requestDetails);
            requestDetails.fromDate = requestDetails.fromDate ? moment(requestDetails.fromDate).format('YYYY-MM-DD') : "";
            requestDetails.toDate = requestDetails.toDate ? moment(requestDetails.toDate).format('YYYY-MM-DD') : "";
            requestDetails.isLocalStorage = true;
            requestDetails.partyId = Number(requestDetails.partyId)
            requestDetails.idAccountHead = requestDetails.idAccountHead
            requestDetails.idTransactionWith = requestDetails.idTransactionWith
            requestDetails.filterExponseById = requestDetails.filterExponseById
            requestDetails.isFromAccountHeadSummary = requestDetails.isFromAccountHeadSummary

            let balanceDetails = {
                fromDate: requestDetails.fromDate,
                toDate: requestDetails.toDate,
                partyId: requestDetails.idAccountHead,
                exponseById: 4
            }
            localStorage.setItem('accountHeadSummary', JSON.stringify(balanceDetails))
            this.setState({ requestDetails: requestDetails });
        } else {
            let details = this.state.requestDetails
            details.fromDate = getFinancialYearDates().fromDate;
            details.toDate = getFinancialYearDates().toDate;
            this.setState({ requestDetails: details })
        }
        if (prop.idCompany && prop.idCompany > 0) {
            this.setState({ idCompany: prop.idCompany, idUser: prop.idUser }, () => {
                this.getSelectedExpenseByList();
                if (this.state.requestDetails.isFromAccountHeadSummary) {
                    this.getSelectedExpenseByListForAccountHeadSummary()
                }
            });
        }
    }

    usp_Master_PartyAccountSelect = () => {
        this.accountTransactionServices.usp_Master_PartyAccountSelect(this.state.idCompany).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.idPartyAccount,
                    label: x.partyACName,
                }));
                this.setState({ partyList: data }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                })
            }
        });
    }

    getSelectedExpenseByList = () => {
        let request = {
            idCompany: this.state.idCompany,
            expenseById: this.state.requestDetails.exponseById,
        }
        this.accountTransactionServices.getSelectedExpenseByList(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.id,
                    label: x.name,
                    openingBalance: x.openingBalance,
                    balanceType: x.openingBlanaceType,
                }));
                this.setState({ partyList: data }, () => {
                    if (this.gridApi) {
                        this.gridApi.hideOverlay();
                    }
                    if (this.state.requestDetails.isLocalStorage === true) {
                        localStorage.removeItem("ledgerReportDetails");
                        this.calculateOpeningBalance()
                    }
                })
            }
        });
    }

    getSelectedExpenseByListForAccountHeadSummary = () => {
        let request = {
            idCompany: this.state.idCompany,
            expenseById: this.state.requestDetails.filterExponseById,
        }
        this.accountTransactionServices.getSelectedExpenseByList(request).then((response) => {
            if (response.statusCode == 200 && response.responseItem !== null) {
                let data = response.responseItem.responseContent;
                data = data.map((x) => ({
                    value: x.id,
                    label: x.name,
                    openingBalance: x.openingBalance,
                    balanceType: x.openingBlanaceType,
                }));
                this.setState({ displayPartyList: data }, () => {
                    let re = this.state.requestDetails
                    console.log(re)
                })
            }
        });
    }

    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.showLoadingOverlay();
    };

    handleChange = (event, name) => {
        let value = event.target.value;
        let details = this.state.requestDetails;
        if (name === "fromDate") {
            details[name] = value
        } else {
            details[name] = value
        }
        this.setState({ requestDetails: details }, () => {
            if (name === 'fromDate' || name === 'toDate') {
                if (this.state.requestDetails.partyId > 0) {
                    let opBalanceObject = this.state.partyList.find(x => x.value === this.state.requestDetails.partyId)
                    let openingBalance = opBalanceObject.openingBalance;
                    let balanceType = opBalanceObject.balanceType === "CREDIT" ? "CR" : "DR";
                    this.setState({ openingBalance: openingBalance, openingBalanceType: balanceType })
                }
            }
        });
    };

    setFilterParameters = (event, name) => {
        let details = this.state.requestDetails;
        details[name] = event.value;
        if (name === "partyId") {
            let openingBalance = event.openingBalance;
            let balanceType = event.balanceType === "CREDIT" ? "CR" : "DR";
            this.setState({ openingBalance: openingBalance, openingBalanceType: balanceType, accountName: event.label });
        } else if (name === "exponseById") {
            details.partyId = 0;
        }
        this.setState({ requestDetails: details }, () => {
            if (name === "exponseById") {
                this.getSelectedExpenseByList();
            }
        });
    }

    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.requestDetails,
            this.state.validationRules,
            this.state.validState,
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    }

    calculateOpeningBalance = () => {
        let isValid = this.isValidAllFields();
        const today = new Date(this.state.requestDetails.fromDate);
        const toDate = new Date(this.state.requestDetails.toDate);

        const reportFromDate = new Date(this.state.requestDetails.fromDate);
        const previousDate = new Date(reportFromDate);
        previousDate.setDate(previousDate.getDate() - 1);

        let financialYearStart;
        if (today.getMonth() + 1 >= 4) {
            financialYearStart = new Date(today.getFullYear(), 3, 1);
        } else {
            financialYearStart = new Date(today.getFullYear() - 1, 3, 1);
        }

        const openingBalanceRequest = {
            fromDate: financialYearStart,
            toDate: previousDate,
            partyId: this.state.requestDetails.partyId,
            exponseById: this.state.requestDetails.exponseById,
            idCompany: this.state.idCompany,
            idAccountHead: this.state.requestDetails.idAccountHead ? this.state.requestDetails.idAccountHead : 0,
            idTransactionWith: this.state.requestDetails.idTransactionWith ? this.state.requestDetails.idTransactionWith : 0
        };

        if (isValid) {
            this.setState({
                isLoading: true,
                openingBalance: 0,
                openingBalanceType: ""
            }, () => {
                this.dailyReportsServices.getLedgerReportRecords(openingBalanceRequest).then((response) => {
                    if (response.statusCode === 200 && response.responseItem !== null) {
                        const totalDebit = response.responseItem.responseContent.reduce((sum, row) => sum + (row.debitAmount || 0), 0);
                        const totalCredit = response.responseItem.responseContent.reduce((sum, row) => sum + (row.creditAmount || 0), 0);

                        const openingDR = this.state.openingBalanceType === "DR" ? Number(this.state.openingBalance) : 0;
                        const openingCR = this.state.openingBalanceType === "CR" ? Number(this.state.openingBalance) : 0;

                        const finalDebit = Number(totalDebit) + Number(openingDR);
                        const finalCredit = Number(totalCredit) + Number(openingCR);

                        let openingBalance = 0;
                        let openingBalanceType = "";

                        if (finalDebit > finalCredit) {
                            openingBalance = finalDebit - finalCredit;
                            openingBalanceType = "DR";
                        } else if (finalCredit > finalDebit) {
                            openingBalance = finalCredit - finalDebit;
                            openingBalanceType = "CR";
                        }

                        this.setState({
                            openingBalance: Number(openingBalance).toFixed(2),
                            openingBalanceType: openingBalanceType
                        }, () => {
                            this.getLedgerReportRecords();
                        });

                    } else {
                        this.SwalServices.showError(response.message);
                        this.setState({ isLoading: false });
                    }
                }).catch((error) => {
                    console.error("Error fetching ledger report:", error);
                    this.setState({ isLoading: false });
                });
            });
        }
    };


    getLedgerReportRecords = () => {
        let isValid = this.isValidAllFields();

        const requestCopy = {
            ...this.state.requestDetails,
            idCompany: this.state.idCompany
        };

        if (isValid) {
            this.dailyReportsServices.getLedgerReportRecords(requestCopy).then((response) => {
                if (response.statusCode === 200 && response.responseItem !== null) {
                    let cumulative = 0;

                    const openingDR = this.state.openingBalanceType === "DR" ? this.state.openingBalance : 0;
                    const openingCR = this.state.openingBalanceType === "CR" ? this.state.openingBalance : 0;
                    cumulative = openingDR - openingCR;

                    const updatedData = response.responseItem.responseContent.map((item) => {
                        const debit = Number(item.debitAmount) || 0;
                        const credit = Number(item.creditAmount) || 0;

                        cumulative += debit;
                        cumulative -= credit;

                        item.cumulativeAmount = Math.abs(cumulative).toFixed(2) + (cumulative >= 0 ? ' DR' : ' CR');
                        item.date = item.date ? moment(item.date).format('DD-MM-YYYY') : "";

                        return item;
                    });

                    this.setState({ rowData: updatedData }, () => {
                        this.setState({ sumRow: this.calculateSumRow() });
                        this.setState({ isLoading: false });
                    });
                } else {
                    this.SwalServices.showError(response.message);
                    this.setState({ isLoading: false });
                }
            }).catch((error) => {
                console.error("Error fetching ledger report:", error);
            });
        }
    };

    calculateSumRow = () => {
        const { rowData, openingBalance, openingBalanceType } = this.state;

        const openingValue = Number(openingBalance) || 0;

        const openingRow = {
            type: "Opening Balance",
            debitAmount: openingBalanceType === "DR" && openingValue > 0 ? openingValue.toFixed(2) : "",
            creditAmount: openingBalanceType === "CR" && openingValue > 0 ? openingValue.toFixed(2) : "",
        };

        const totalDebit = rowData.reduce((sum, row) => sum + Number(row.debitAmount || 0), 0);
        const totalCredit = rowData.reduce((sum, row) => sum + Number(row.creditAmount || 0), 0);

        const totalRow = {
            type: "Total(DR/CR)",
            debitAmount: totalDebit > 0 ? totalDebit.toFixed(2) : '',
            creditAmount: totalCredit > 0 ? totalCredit.toFixed(2) : '',
        };

        const openingDR = openingBalanceType === "DR" ? openingValue : 0;
        const openingCR = openingBalanceType === "CR" ? openingValue : 0;

        const finalDebit = totalDebit + openingDR;
        const finalCredit = totalCredit + openingCR;

        let closingAmount = 0;
        let closingType = "";

        if (finalDebit > finalCredit) {
            closingAmount = finalDebit - finalCredit;
            closingType = "DR";
        } else if (finalCredit > finalDebit) {
            closingAmount = finalCredit - finalDebit;
            closingType = "CR";
        }

        const closingRow = {
            type: "Closing Balance",
            debitAmount: closingType === "DR" ? closingAmount.toFixed(2) + " DR" : "",
            creditAmount: closingType === "CR" ? closingAmount.toFixed(2) + " CR" : "",
        };

        const grandTotal = {
            type: "Grand Total",
            debitAmount: (finalDebit + (closingType === "CR" ? closingAmount : 0)).toFixed(2),
            creditAmount: (finalCredit + (closingType === "DR" ? closingAmount : 0)).toFixed(2),
        };

        return [openingRow, totalRow, closingRow, grandTotal];
    };

    onRowDoubleClicked = (event) => {
        let details = event.data;
        const encryptId = encryptAES(details.id);
        localStorage.setItem("ledgerReportDetails", JSON.stringify(this.state.requestDetails));
        let route = `/${details.redirect}?id=${encryptId}`;
        this.setState({ route: route });
    };

    onExportExcel = () => {
        const { fromDate, toDate } = this.state.requestDetails;
        const { accountName } = this.state;

        if (this.gridRef.current && this.gridRef.current.api) {
            const csvData = this.gridRef.current.api.getDataAsCsv();

            const customHeader = [
                [`Account: ${accountName}`, '', '', ''].join(','),
                [`From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`, '', '', ''].join(','),
                '' // Blank line
            ].join('\r\n');

            const finalCsv = `${customHeader}\r\n${csvData}`;

            const blob = new Blob([finalCsv], { type: 'text/csv;charset=utf-8;' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Ledger_Report.csv');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            console.warn("Grid API not ready");
        }
    };

    onExportPdf = () => {
        const doc = new jsPDF();

        const { fromDate, toDate } = this.state.requestDetails;
        const { accountName } = this.state;

        const pageWidth = doc.internal.pageSize.getWidth();

        // Header content
        const headerLines = [
            `Account: ${accountName}`,
            `From: ${moment(fromDate).format('DD-MM-YYYY')} To: ${moment(toDate).format('DD-MM-YYYY')}`
        ];

        // Header styles
        const headerFontSize = 12;
        const headerTextColor = [80, 80, 80]; // white
        const headerBgColor = [245, 245, 245]; // blue
        const lineHeight = 8;
        const padding = 2;

        // Calculate total header height
        const totalHeaderHeight = headerLines.length * lineHeight + padding * 2;

        // Draw background rectangle for header
        doc.setFillColor(...headerBgColor);
        doc.rect(0, 0, pageWidth, totalHeaderHeight, 'F');

        // Set text styles
        doc.setFontSize(headerFontSize);
        doc.setTextColor(...headerTextColor);

        // Draw each header line centered
        headerLines.forEach((line, i) => {
            const textWidth = doc.getTextWidth(line);
            const x = (pageWidth - textWidth) / 2;
            const y = padding + (i + 1) * lineHeight - 2;
            doc.text(line, x, y);
        });

        // Prepare table data
        const exportableCols = this.state.colDefs.filter(col => col.headerName !== "Sr No");

        const rowData = [];
        this.gridRef.current.api.forEachNodeAfterFilterAndSort((node) => {
            rowData.push(exportableCols.map(col => node.data[col.field]));
        });

        const pinnedBottomRows = this.gridRef.current.api.getPinnedBottomRowCount();
        for (let i = 0; i < pinnedBottomRows; i++) {
            const pinnedNode = this.gridRef.current.api.getPinnedBottomRow(i);
            rowData.push(exportableCols.map(col => pinnedNode.data[col.field]));
        }

        const columnHeaders = exportableCols.map(col => col.headerName);

        // Render table below header
        autoTable(doc, {
            head: [columnHeaders],
            body: rowData,
            startY: totalHeaderHeight + 4, // leave space below header
            styles: { fontSize: 8 },
            headStyles: { fillColor: [63, 140, 255], textColor: 255 },
        });

        doc.save("ledger-report.pdf");
    };

    render() {
        if (this.state.route != null) {
            return <Navigate to={this.state.route} />;
        }
        return (
            <div className='profit-loss-report'>
                <div className='data-display'>
                    <div className='data-display-inner relative'>
                        <div className='search-grp bg-white shadow-normalShadow rounded-[10px] p-[10px] w-[100%] mb-[10px]'>
                            <div className='item-grp flex gap-[10px] items-end'>
                                <div className='input-grp w-[15%]'>
                                    <label>Ledger for</label>
                                    <MultiSelectDropdown
                                        className={this.state.validState?.error?.exponseById !== undefined ? "error" : ""}
                                        options={this.state.expenseByList}
                                        value={this.state.requestDetails.exponseById ? this.state.expenseByList?.find(item => item.value === this.state.requestDetails.exponseById) : 0}
                                        onChange={(event) =>
                                            this.setFilterParameters(event, "exponseById")
                                        }
                                    />
                                </div>
                                <div className='input-grp w-[45%]'>
                                    <label>Ledger of</label>
                                    <MultiSelectDropdown
                                        className={this.state.validState?.error?.partyId !== undefined ? "error" : ""}
                                        options={this.state.partyList}
                                        value={this.state.requestDetails.partyId ? this.state.partyList?.find(item => item.value === this.state.requestDetails.partyId) : 0}
                                        onChange={(event) =>
                                            this.setFilterParameters(event, "partyId")
                                        }
                                    />
                                </div>
                                {this.state.requestDetails.isFromAccountHeadSummary ?
                                    <div className='input-grp w-[45%]'>
                                        <label>For</label>
                                        <MultiSelectDropdown
                                            options={this.state.displayPartyList}
                                            value={this.state.requestDetails.idTransactionWith ? this.state.displayPartyList?.find(item => item.value === Number(this.state.requestDetails.idTransactionWith)) : 0}
                                            isDisabled={true}
                                        />
                                    </div>
                                    : null}
                                <div className='input-grp w-[15%]'>
                                    <label>From date</label>
                                    <input type='date'
                                        className={`px-[10px] py-[5px] ${this.state.validState?.error?.fromDate !== undefined ? "error" : ""}`}
                                        value={this.state.requestDetails.fromDate}
                                        onChange={(event) => this.handleChange(event, "fromDate")}
                                    />
                                </div>
                                <div className='input-grp w-[15%]'>
                                    <label>To date</label>
                                    <input type='date'
                                        className={`px-[10px] py-[5px] ${this.state.validState?.error?.toDate !== undefined ? "error" : ""}`}
                                        value={this.state.requestDetails.toDate}
                                        onChange={(event) => this.handleChange(event, "toDate")}
                                    />
                                </div>
                                {this.state.isLoading ?
                                    <ButtonLoader />
                                    :
                                    <>
                                        <button className='prm-btn h-fit !w-[10%] justify-center'
                                            onClick={() => this.calculateOpeningBalance()}
                                        >
                                            Search
                                        </button>
                                        <button className='prm-btn h-fit !w-[10%] justify-center'
                                            onClick={() => window.location.reload()}
                                        >
                                            <FontAwesomeIcon
                                                icon={faRotateRight}
                                                className='text-white text-[20px]'
                                            />
                                        </button>
                                    </>
                                }
                            </div>
                        </div>
                        <div className="table cursor-default w-full bg-white shadow-normalShadow rounded-[10px] pb-[44px] pt-[10px] px-[10px]">
                            <div className="table-1 w-full px-[1px] rounded-[5px]" style={{ height: "calc(100vh - 261px)" }}>
                                <div className="table-inner flex items-center justify-between mb-2.5">
                                    <h1 className="text-blue text-[16px] font-semibold py-[5px] px-[9px] pt-[0]">Ledger report</h1>
                                    <div className='btn-grp flex items-center gap-2.5'>
                                        {this.state.rowData.length > 0 ?
                                            <>
                                                <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportExcel()}>Export to Excel</button>
                                                <button className='prm-btn h-fit text-[14px] rounded-[8px] px-[16px] py-[8px]' onClick={() => this.onExportPdf()}>Export to PDF</button>
                                            </>
                                            : null}
                                    </div>
                                </div>
                                <AgGridReact
                                    ref={this.gridRef}
                                    rowData={this.state.rowData}
                                    rowHeight={this.state.rowHeight}
                                    columnDefs={this.state.colDefs}
                                    onRowDoubleClicked={this.onRowDoubleClicked}
                                    // onGridReady={this.onGridReady}
                                    overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                                    overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                                    pinnedBottomRowData={this.state.sumRow}
                                    rowClassRules={{
                                        "sum-row": (params) => params.node.rowPinned === "bottom"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}